import getAlertService from '../services/components/get_alert.jsx'


const getState = (alertState) => ({ type: "GET_ALERT", alertState})

export const getAlertAction = (cardDetailsId) => dispatch => {
    let state = [];

    getAlertService((data, msg) => {
        if (msg === "success") {
            state = {
                status: 200,
                body: data
            }
            localStorage.setItem("alertState", JSON.stringify(state))
        } else {
            state = data
        }
        dispatch(getState(state))
    },cardDetailsId)
} 


// WEBPACK FOOTER //
// ./src/actions/getalertaction.jsx